import "./Reusable.css"
import { Routes, Route } from 'react-router-dom'
import CrmExtract from './features/crm/CrmExtract'
import CrmList from './features/crm/CrmList'
import ManageUser from './features/user/ManageUser'
import Prefetch from './features/auth/Prefetch'
import RequireAuth from './features/auth/RequireAuth'
import PasswordChange from './features/user/PasswordChange'
import RequirePasswordChange from './features/auth/RequirePasswordChange'
import Logout from './features/auth/Logout'
import Require2FA from './features/auth/2fa/Require2FA'
import Verify2FA from './features/auth/2fa/Verify2FA'
import SupportStaff from './features/crm/support/SupportStaff'
import Error403Page from './components/Error403Page'
import CustomReports from './features/report/CustomReports'
import CustomReportTemplate from './features/report/CustomReportTemplate'
import Forms from "./features/form/Forms"
import CrmEditor from "./features/crm/fileDetails/CrmEditor"
import FormRequestManager from "./features/form/FormRequestManager"
import DashHeader from "./components/DashHeader"
import Ras from "./components/ras/ras"
import FormDocuSignConnectSuccess from "./features/form/FormDocuSignConnectSuccess"
import FormDocuSignConnectFailed from "./features/form/FormDocuSignConnectFailed"
import BookOfBusinessForm from "./features/bob/BookOfBusinessForm"
import RequireBobForm from "./features/bob/RequireBobForm"
import BulkRequest from "./features/bulk/BulkRequest"
import LandingRedirect from "./components/landing/LandingRedirect"

function App() {
  return (
    <Routes>
      <Route index element={<LandingRedirect />} />
        <Route element={<RequireAuth allowedRoles={['EMPLOYEE', 'ADVISOR', 'SUPPORT_STAFF']} />}>
          <Route path="logout" element={<Logout />} />
          <Route path="verify" element={<Verify2FA />} />
          <Route element={<Require2FA />}>
            <Route path="dash" element={<DashHeader />}>
              <Route path='error403' element={<Error403Page />} />
              <Route path="passwordChange" element={<PasswordChange />} />
              <Route element={<RequirePasswordChange />}>
                <Route path="bob" element={<BookOfBusinessForm />} />
                <Route element={<RequireBobForm />}>
                  <Route path="crm/:id" element={<CrmEditor />} />
                  <Route element={<RequireAuth allowedRoles={['EMPLOYEE']} />}>
                    <Route element={<Prefetch />}>
                      <Route index element={<CrmExtract />} />
                      <Route path="crmList" element={<CrmList />} />
                      <Route path="manageForms" element={<FormRequestManager />} />
                      <Route path="manageUser" element={<ManageUser />} />
                    </Route> 
                  </Route>
                  <Route element={<RequireAuth allowedRoles={['SUPPORT_STAFF']} />}>
                    <Route path="support" element={<SupportStaff />} />
                  </Route>
                  <Route element={<RequireAuth allowedRoles={['ADVISOR']} />}>
                      <Route path="forms" element={<Forms />} />
                      <Route path="bulk" element={<BulkRequest />} />
                  </Route>
                  <Route element={<RequireAuth allowedRoles={['SUPPORT_STAFF', 'ADVISOR']} />}>
                    <Route path="customReports" element={<CustomReports />} />
                    <Route path="customReports/:crmId/template/:templateId" element={<CustomReportTemplate />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
      </Route>
      <Route path="ras" element={<Ras />} />
      <Route path="docusign/success" element={<FormDocuSignConnectSuccess />} />
      <Route path="docusign/failed" element={<FormDocuSignConnectFailed />} />
    </Routes>
  )
}

export default App
